// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9748) return "static/chunks/9748-e51c911ec28f13e0.js";
	if (chunkId === 1240) return "static/chunks/1240-3428c4c5bf91f14f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3070":"8012d7e2","9562":"3975359d"}[chunkId] || chunkId) + "." + {"796":"9fd67d9956f2a657","2080":"8f9353e7c75ec10b","2353":"e1746676fdbd8c4f","3070":"575bef338fe29d11","6233":"87230463417127b0","9562":"4a0c5ab33720b6aa"}[chunkId] + ".js";
};